import { flexRender } from '@tanstack/react-table';
import { useRef } from 'react';
import styles from './Table.module.scss.js';
import { jsx, Fragment } from 'react/jsx-runtime';
import { useColorWeight } from '../theme/util.js';
import { getTextVariantClassName } from '../text/Text.js';
import classNames from 'clsx';

const textVariants = {
  default: {
    false: 'body-compact',
    true: 'body-compact-bold'
  },
  small: {
    false: 'body-small-compact',
    true: 'body-small-compact-bold'
  }
};
function DataCell(props) {
  const {
    cell
  } = props;
  const ctx = cell.getContext();
  const {
    column,
    row,
    table
  } = ctx;
  const {
    align,
    verticalAlign,
    cellBorder,
    className: callerClassNameFnOrVal,
    color,
    prominent
  } = column.columnDef.meta;
  const hasColor = !!color;
  const cellColor = color?.(row.original) ?? 'color-neutral';
  const isProminent = prominent?.(row.original) ?? false;
  const {
    size = 'default'
  } = table.options.meta;
  const ref = useRef(null);
  const backgroundColor = useColorWeight(cellColor, '50', ref);
  const textColor = useColorWeight(cellColor, '600', ref);
  const prominentTextColor = useColorWeight(cellColor, '700', ref);
  const style = {};
  if (hasColor) {
    if (isProminent) {
      style.color = prominentTextColor;
      style.backgroundColor = backgroundColor;
    } else {
      style.color = textColor;
    }
  }
  const textVariant = getTextVariantClassName(textVariants[size][String(isProminent)]);
  const callerClassName = callerClassNameFnOrVal && typeof callerClassNameFnOrVal === 'function' ? callerClassNameFnOrVal(row.original) : callerClassNameFnOrVal;
  const className = classNames('dsx-component', callerClassName, textVariant, align && styles[`body-${align}`], verticalAlign && styles[`valign-${verticalAlign}`], cellBorder && styles[`cell-border-${cellBorder}`]);
  return /*#__PURE__*/jsx("td", {
    className: className,
    style: style,
    "data-dsx--table--cell": column.id,
    ref: ref,
    children: flexRender(column.columnDef.cell, cell.getContext())
  });
}
function DataCellContent(ctx) {
  const {
    column,
    row
  } = ctx;
  const {
    render
  } = column.columnDef.meta;
  if (render) {
    return render(row.original) ?? /*#__PURE__*/jsx(Fragment, {});
  }
  return ctx.getValue() ?? /*#__PURE__*/jsx(Fragment, {});
}

export { DataCell, DataCellContent };
